Router = App.loadClass 'core::Router'

class exports.ProfileRouter extends Router

    prefix: 'Profile'
    module_name: 'ProfileRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'grower::Angular/Profile/ProfileService', ['$http']

        @controller 'grower::Angular/Profile/MainController', [
            '$scope'
            '$transitions'
            '$uibModal'
        ]

        @controller 'grower::Angular/Profile/ProfileController', [
            '$scope'
            '$transitions'
            '$uibModalInstance'
            'ProfileData'
        ]
